/* eslint-disable @typescript-eslint/no-useless-constructor */
import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IActivity, IActivityNotificationsState } from 'typings/doenkids/doenkids';
import { TUserEntityPermission } from 'typings/api-generic';

export interface IStoreActivity {
  id: number;
  data: IActivity;
  access_level: TUserEntityPermission;
  notifications_state?: IActivityNotificationsState;
  original?: {
    id: number;
    status_id: number;
    name: string;
    language: string;
    country_code: string;
    created_at: string;
    updated_at: string;
    archived: boolean;
  };
}

export interface IActivityState extends EntityState<IStoreActivity> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'activity' })
export class ActivityStore extends EntityStore<IActivityState, IStoreActivity> {
  constructor() {
    super();
  }
}
